import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormationsFormComponent } from '../../../../../pages/manage-formations/formations-form/formations-form/formations-form.component';
import { FormationsService } from '../../../../../../../services/formations.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-edit-formation',
  imports: [FormationsFormComponent],
  templateUrl: './edit-formation.component.html',
  styleUrl: './edit-formation.component.scss'
})
export class EditFormationComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private formationsService = inject(FormationsService);
  private messageService = inject(MessageService);
  formationId: string = this.route.snapshot.paramMap.get('id') || '';
  formations = signal<any[]>([]);
  ngOnInit(): void {
    this.formationsService.getFormationById(parseInt(this.formationId)).subscribe({
      next: (data) => {
        const list = data
        this.formations.set(list);
        console.log("this is the formation", this.formations())
      },
      error: () => {
        console.log("error while loading the formation")
      }
    });

  }

  onEdit(formData: any) {
    console.log("edit button was clicked")
    this.formationsService.editFormation(formData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Formation créée',
          detail: 'La formation a été modifiée avec succès',
          life: 5000
        });
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors de la modification de la formation',
          life: 5000
        });
      }
    });


  }


}
